module.exports = __webpack_public_path__ + "img/home_2.3df97210.jpg";